<nb-select fullWidth
           [(selected)]="value"
           [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="">Alle</nb-option>
  <nb-option [value]="NotificationVariant.Normal">Information</nb-option>
  <nb-option [value]="NotificationVariant.Warning">Warnung</nb-option>
  <nb-option [value]="NotificationVariant.Error">Fehler</nb-option>
  <nb-option [value]="NotificationVariant.Success">Erfolg</nb-option>
</nb-select>
